import { maskEmail } from './oktaUtils';
import classess from './OktaSignInWidget.scss';

function voiceButton() {
  const voiceButton = document.querySelector('#okta-sign-in .phone-authenticator-challenge__link');
  if (voiceButton) {
    voiceButton.classList.add(classess.button);
    voiceButton.style.height = '42px';
    voiceButton.style.display = 'grid';
    voiceButton.style.placeItems = 'center';
    voiceButton.style.fontWeight = '700';
    voiceButton.style.fontSize = '16px';
    voiceButton.style.border = '1px solid black';
    voiceButton.style.borderRadius = '4px';
    voiceButton.style.padding = '8px 24px';
    voiceButton.style.lineHeight = '24px';
    voiceButton.style.color = '#1A76C5';
    voiceButton.style.background = '#FFFFFF';
    voiceButton.style.textTransform = 'uppercase';
  }
}

function OktaPhoneScreenCssAlt (){
  const emailElement = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier');
  if(emailElement){
    emailElement.textContent = maskEmail(emailElement.textContent);
    emailElement.classList.add(classess.emailText);
  }

  const emailElementParentDiv = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier-container');
  const parentElement=document.querySelector('#okta-sign-in .auth-content .o-form-content');
  const verifyElement= document.querySelector('#okta-sign-in .auth-content .o-form-content .verify-message');
  //adding the emailElement after LogIn text
  if ( emailElementParentDiv && parentElement && verifyElement) {
    parentElement.insertBefore(emailElementParentDiv, verifyElement);
  }
}

export default function OktaPhoneScreenCss(phoneIcon) {

  const verifyMessage = document.createElement('div');
  if (!document.querySelector('.verify-message')) {
    verifyMessage.className = 'verify-message';
    verifyMessage.style.display = 'flex';
    verifyMessage.style.alignItems = 'center';
    verifyMessage.style.marginTop = '25px';

    const verifyImage = document.createElement('div');
    verifyImage.style.backgroundImage = `url(${phoneIcon})`;
    verifyImage.style.height = '32px';
    verifyImage.style.width = '32px';
    verifyImage.style.marginRight = '10px';

    const verifyContent = document.createElement('div');
    verifyContent.textContent = 'Verify with Your Phone';
    verifyContent.style.fontWeight = '700';
    verifyContent.style.color = '#4F4F4F';
    verifyContent.style.textAlign = 'left';
    verifyContent.style.fontSize = '18px';
    verifyContent.style.lineHeight = '18px';
    verifyContent.classList.add(classess.textSizeSM);
    verifyMessage.appendChild(verifyImage);
    verifyMessage.appendChild(verifyContent);

    const refElement = document.querySelector('#okta-sign-in .siw-main-view .siw-main-body .identifier-container');
    if (refElement) {
      refElement.parentNode.insertBefore(verifyMessage, refElement);
      refElement.style.textAlign = 'left';
      refElement.style.marginTop = '15px';
      refElement.style.marginBottom = '0px';
      refElement.style.display='flex';
      refElement.style.justifyContent='center';
      refElement.classList.add(classess.humanLogoVerifyScreen);
    }
  }

  const resendLink = document.getElementsByClassName('resend-link');
  if(resendLink.length !== 0){
    resendLink[0].setAttribute('href','javascript:void(0)');
  }
  
  const codeInput = document.querySelector('input[name="credentials.passcode"]');
  if (codeInput) {
    codeInput.addEventListener('input', function (event) {
      // Remove any non-numeric characters
      codeInput.value = codeInput.value.replace(/[^0-9]/g, '');
    });
  }

  OktaPhoneScreenCssAlt();
  
  const sendPhoneContent = document.querySelector('#okta-sign-in.auth-container .okta-form-subtitle');
  if (sendPhoneContent) {
    sendPhoneContent.style.marginTop = '0px';
    sendPhoneContent.style.textAlign = 'left';
    sendPhoneContent.classList.add(classess.textSizeS) ;
    sendPhoneContent.childNodes.forEach(node =>{
      if(node.nodeType  === Node.TEXT_NODE){
        node.textContent = node.textContent.replace('Enter the code below to verify.','');
      }
    });
  }

  const sendPhoneCharges = document.querySelector('#okta-sign-in .phone-authenticator-challenge .okta-form-subtitle p');
  if (sendPhoneCharges) {
    sendPhoneCharges.style.marginTop = '0px';
  }

  voiceButton();

}